<template>
    <v-container fluid :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''">
        <v-card :rounded="$vuetify.breakpoint.smAndDown ? '0' : '10'">
            <v-card-title primary-title>
                <v-row justify="space-between">
                    <v-col cols="10">
                        <div
                            v-if="$vuetify.breakpoint.xs"
                            class="primary--text text-overline ml-2"
                        >
                            Estadísticas
                            <small class="grey--text d-flex justify-start">{{
                                dateFilter.join(' - ')
                            }}</small>
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            <div class="d-flex align-center">
                                <v-icon x-large color="primary" left>
                                    mdi-chart-areaspline
                                </v-icon>
                                Estadísticas
                            </div>
                            <small class="grey--text d-flex justify-start">{{
                                dateFilter.join(' - ')
                            }}</small>
                        </div>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end align-center">
                        <v-btn
                            fab
                            color="orange"
                            depressed
                            @click="openFilterDialog"
                        >
                            <v-icon color="white" size="30">mdi-magnify</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-row>
                    <v-col cols="12" md="12">
                        <StatsVentasObjetivo />
                    </v-col>
                    <v-col cols="12" md="12">
                        <StatsComerciales />
                    </v-col>
                    <!-- <v-col cols="12" md="6">
                        <StatsVentasMes />
                    </v-col> -->
                </v-row>
            </v-card-text>
        </v-card>
        <ComercialesTableFilterDialog
            @dataDateComercialForm="onClickChild($event)"
        />
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import StatsVentasObjetivo from './StatsVentasObjetivo.vue';
import StatsVentasMes from './StatsVentasMes.vue';
import StatsComerciales from './StatsComerciales.vue';
import ComercialesTableFilterDialog from '@/components/GerenciaTeletrabajo/ComercialesTable/ComercialesTableFilterDialog.vue';

export default {
    name: 'Stats',
    components: {
        StatsVentasObjetivo,
        StatsVentasMes,
        StatsComerciales,
        ComercialesTableFilterDialog,
    },
    data() {
        return {};
    },
    created() {
        this.getVentasObjetivo();
        this.getComercialesStats();
    },
    methods: {
        onClickChild({ dateFilter, stateComercial, selectedTipoComercial }) {
            this.dateFilter = dateFilter;
            this.selectedState = stateComercial;
            this.selectedTipoComercial = selectedTipoComercial;
            this.getVentasObjetivo();
            this.getComercialesStats();
        },
        openFilterDialog() {
            this.$store.commit('gerencia/isOpenFilterDialog', true);
        },
        ...mapActions('statistics', [
            'getVentasObjetivo',
            'getComercialesStats',
        ]),
    },
    computed: {
        dateFilter: {
            get() {
                return this.$store.state.statistics.filters.dateFilter;
            },
            set(val) {
                this.$store.commit('statistics/filtersDateFilter', val);
            },
        },
        selectedState: {
            get() {
                return this.$store.state.statistics.filters.selectedState;
            },
            set(val) {
                this.$store.commit('statistics/filtersSelectedState', val);
            },
        },
        selectedTipoComercial: {
            get() {
                return this.$store.state.statistics.filters
                    .selectedTipoComercial;
            },
            set(val) {
                this.$store.commit(
                    'statistics/filtersSelectedTipoComercial',
                    val
                );
            },
        },
    },
};
</script>

<style>
.test {
    border-width: 1px !important;
    border-color: #e0e0e0 !important;
    height: 100%;
}

.small {
    max-width: 600px;
    margin: 150px auto;
}
</style>
